/* eslint-disable camelcase */
import LongGridInitConfig from './LongGridInitConfig'
import WideGridInitConfig from './WideGridInitConfig'
// import Dimension from './Dimension'

export default class InitConfig {
  constructor ({ long_grid, wide_grid, shared }) {
    this.longGrid = new LongGridInitConfig(long_grid)
    this.wideGrid = new WideGridInitConfig(wide_grid)
    // this.dimensions = shared.dimensions.map((dimension) => new Dimension(dimension))
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/InitConfig.js